import { render, staticRenderFns } from "./ContactDuplicatesManager.vue?vue&type=template&id=155905b0"
import script from "./ContactDuplicatesManager.vue?vue&type=script&lang=js"
export * from "./ContactDuplicatesManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports